export default __webpack_public_path__ + "static/media/office_-1.5feef254.jpg";